import { Injectable } from '@angular/core';
import { ApplicationDocuments } from '@edassist/api';

@Injectable({ providedIn: 'root' })
export class DocumentUtilityService {
	static getIsReviewDisabled(
		document: ApplicationDocuments,
		canReviewDocuments: boolean,
		canUnReviewDocuments: boolean
	): boolean {
		return !(
			(!document.received && canReviewDocuments) ||
			(document.received && canUnReviewDocuments)
		);
	}
}
